// cart-lines.js - render items + qty controls, unified via PBCart
const TRASH_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none" aria-hidden="true" focusable="false">
  <path d="M6.78588 4.08899V2.39273C6.78588 2.02465 6.92886 1.67165 7.18337 1.41137C7.43789 1.1511 7.78308 1.00488 8.14302 1.00488H10.8573C11.2172 1.00488 11.5624 1.1511 11.8169 1.41137C12.0715 1.67165 12.2144 2.02465 12.2144 2.39273V4.08899M15.0418 4.08899L14.2502 13.4955C14.2502 13.8636 14.1072 14.2166 13.8527 14.4769C13.5981 14.7372 13.253 14.8834 12.893 14.8834H6.10731C5.74737 14.8834 5.40217 14.7372 5.14766 14.4769C4.89315 14.2166 4.75016 13.8636 4.75016 13.4955L3.9585 4.08899H15.0418Z" stroke="#092A51" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3.1665 4.08887H4.57391H15.8332" stroke="#092A51" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M7.9165 7.17285V11.028" stroke="#092A51" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11.0835 7.17285V11.028" stroke="#092A51" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

(function () {
  const drawer =
    document.querySelector('[data-pb-cart-drawer="primary"]') ||
    document.getElementById('UnifiedCartDrawer');
  if (!drawer) return;

  const list = document.getElementById('CartLineItems');
  const subtotalEl = document.getElementById('CartSubtotal');
  const checkoutSubtotalEl = document.getElementById('CartCheckoutSubtotal');
  const discountRowEl = document.getElementById('CartDiscountRow');
  const discountAmountEl = document.getElementById('CartDiscountAmount');
  const countBadgeEl = document.getElementById('CartCountBadge');

  function log(...a) {
    try {
      console.log('[UCD][lines]', ...a);
    } catch (e) {}
  }

  // Currency of the cart as returned by the Storefront API. A cart in another
  // market (e.g. EU Zone 2 with local currencies: SE → SEK, DK → DKK) returns its
  // amounts in that currency, so never assume EUR. Set by normalizeCart().
  let cartCurrency = 'EUR';

  function formatMoney(cents) {
    const v = Math.max(0, Number(cents) || 0) / 100;

    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: cartCurrency
      }).format(v);
    } catch {
      const amount = v.toFixed(2).replace('.', ',');
      return cartCurrency === 'EUR' ? '€' + amount : `${cartCurrency} ${amount}`;
    }
  }

  const bundleOpenByKey = Object.create(null);
  const USE_VISUAL_PICK_MIX_DISCOUNT = true;
  const LINE_ORDER_STORAGE_KEY = 'pb_cart_line_order_v1';

  // Tracks first-seen order of cart lines so the most recently added line
  // renders at the top of the list (newest-first), independent of API ordering.
  const lineOrderSeq = new Map(readStoredLineOrder());
  let lineOrderCounter = Math.max(0, ...lineOrderSeq.values());

  function readStoredLineOrder() {
    try {
      const stored = JSON.parse(sessionStorage.getItem(LINE_ORDER_STORAGE_KEY) || '[]');
      if (!Array.isArray(stored)) return [];

      return stored.filter((entry) => {
        return Array.isArray(entry) && typeof entry[0] === 'string' && Number.isFinite(entry[1]);
      });
    } catch {
      return [];
    }
  }

  function persistLineOrder() {
    try {
      const recentEntries = [...lineOrderSeq.entries()]
        .sort((a, b) => a[1] - b[1])
        .slice(-200);
      sessionStorage.setItem(LINE_ORDER_STORAGE_KEY, JSON.stringify(recentEntries));
    } catch {}
  }

  function orderSeqFor(key) {
    if (!lineOrderSeq.has(key)) {
      lineOrderSeq.set(key, ++lineOrderCounter);
      persistLineOrder();
    }
    return lineOrderSeq.get(key);
  }

  function decodeHtml(value) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = String(value || '');
    return textarea.value;
  }

  function escapeAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isGiftItem(item) {
    const props = item?.properties;
    if (!props) return false;
    return props._auto_gift === 'true' || props._beauty_bag === 'true' || !!props._pb_gift;
  }

  function readGiftTierLabels() {
    const labelsByVariant = new Map();

    drawer.querySelectorAll('[data-tier]').forEach((node) => {
      if (node.dataset.rewardType !== 'free_product') return;

      const variantId = Number(node.dataset.giftVariantId);
      const label = decodeHtml(node.dataset.productLabel || '').trim();

      if (Number.isFinite(variantId) && variantId > 0 && label) {
        labelsByVariant.set(variantId, label);
      }
    });

    return labelsByVariant;
  }

  function getGiftBadgeLabel(item) {
    const labelsByVariant = readGiftTierLabels();
    const variantGid = item?.id || '';
    const variantId = Number(String(variantGid).split('/').pop());

    if (Number.isFinite(variantId) && labelsByVariant.has(variantId)) {
      return labelsByVariant.get(variantId);
    }

    const firstLabel = labelsByVariant.values().next().value;
    return firstLabel || 'Gratis cadeau';
  }

  function giftCampaignKey(item) {
    if (!item?.properties) return null;
    if (item.properties._pb_gift) return item.properties._pb_gift;
    if (item.properties._beauty_bag === 'true') return 'beauty-bag';
    return null;
  }

  function suppressGiftReadd(item) {
    const variantGid = item?.id || '';
    const numericVid = Number(String(variantGid).split('/').pop());

    try {
      const store = JSON.parse(sessionStorage.getItem('ucd_suppressed_gift_variants') || '[]');

      if (Number.isFinite(numericVid) && !store.includes(numericVid)) {
        store.push(numericVid);
      }

      sessionStorage.setItem('ucd_suppressed_gift_variants', JSON.stringify(store));
    } catch (e) {}

    const giftKey = giftCampaignKey(item);

    if (giftKey && typeof window.pbGiftSuppress === 'function') {
      window.pbGiftSuppress(giftKey);
    }
  }

  function encodeJsonAttr(value) {
    try {
      return encodeURIComponent(JSON.stringify(value || []));
    } catch {
      return encodeURIComponent('[]');
    }
  }

  function decodeJsonAttr(value) {
    try {
      return JSON.parse(decodeURIComponent(value || '%5B%5D'));
    } catch {
      return [];
    }
  }

  function parseDiscountPercent(value) {
    const n = Number(String(value || '').replace('%', '').trim());
    return Number.isFinite(n) ? n : 0;
  }

  function getPickMixEditUrl(bundleId) {
  try {
    if (bundleId) {
      const byId = localStorage.getItem(`pb_pick_mix_edit_url_${bundleId}`);
      if (byId) return byId;
    }

    const latest = localStorage.getItem('pb_pick_mix_edit_url_latest');
    if (latest) return latest;

    if (window.PB_PICK_MIX_DEFAULT_EDIT_URL) {
      return window.PB_PICK_MIX_DEFAULT_EDIT_URL;
    }

    return '/pages/pick-mix?pm_edit=1';
  } catch {
    return window.PB_PICK_MIX_DEFAULT_EDIT_URL || '/pages/pick-mix?pm_edit=1';
  }
}

  function getPickMixDisplayItems(bundleId) {
    if (bundleId && window.PB_PICK_MIX_DISPLAY_BY_ID?.[bundleId]?.length) {
      return window.PB_PICK_MIX_DISPLAY_BY_ID[bundleId];
    }

    if (window.PB_LAST_PICK_MIX_DISPLAY?.length) {
      return window.PB_LAST_PICK_MIX_DISPLAY;
    }

    try {
      if (bundleId) {
        const byId = JSON.parse(localStorage.getItem(`pb_pick_mix_display_${bundleId}`) || '[]');
        if (Array.isArray(byId) && byId.length) return byId;
      }

      const latest = JSON.parse(localStorage.getItem('pb_pick_mix_display_latest') || '[]');
      return Array.isArray(latest) ? latest : [];
    } catch {
      return [];
    }
  }

  function isGenericPickMixTitle(title) {
    return !title || /^pick\s*&\s*mix(?:\s+bundle)?$/i.test(String(title).trim());
  }

  function readPickMixChromeStore(bundleId) {
    try {
      const key = bundleId
        ? `pb_pick_mix_chrome_${bundleId}`
        : 'pb_pick_mix_chrome_latest';
      const stored = JSON.parse(localStorage.getItem(key) || 'null');

      if (stored && typeof stored === 'object') {
        return stored;
      }
    } catch {
      // Ignore unavailable or invalid storage.
    }

    return {};
  }

  function getPickMixChrome(bundleId, attrs) {
    const properties = attrs || {};
    const which = String(properties._pick_mix_which || '');
    const storedById = readPickMixChromeStore(bundleId);
    const storedLatest = which === 'SMYLE' ? readPickMixChromeStore('') : {};
    const propertyTitle = decodeHtml(
      properties._pick_mix_title ||
      properties.pb_pick_mix_title ||
      ''
    );
    const storedTitle = storedById.title || storedLatest.title || '';
    const useStoredTitle = Boolean(storedTitle) && isGenericPickMixTitle(propertyTitle);

    return {
      title: useStoredTitle ? decodeHtml(storedTitle) : propertyTitle,
      image:
        properties._pick_mix_image ||
        properties.pb_pick_mix_image ||
        storedById.image ||
        storedLatest.image ||
        ''
    };
  }

  function isPickMixLine(item) {
    if (!item || !item.properties) return false;

    // If Cart Transform already made this into one Shopify bundle line,
    // do not group it again inside the drawer.
    if (item.isPickMixTransformedLine || item.isBundle) return false;

    const props = item.properties;

    return (
      (props._pick_mix === 'true' && props._pick_mix_id) ||
      (props.pb_pick_mix === 'true' && props.pb_pick_mix_id)
    );
  }

  function groupPickMixLines(items) {
    const result = [];
    const groups = Object.create(null);

    items.forEach((item) => {
      if (!isPickMixLine(item)) {
        result.push(item);
        return;
      }

      const groupId = item.properties._pick_mix_id || item.properties.pb_pick_mix_id;
      const chrome = getPickMixChrome(groupId, item.properties);
      const title = chrome.title || 'Pick & Mix';

      if (!groups[groupId]) {
        groups[groupId] = {
          key: `pickmix_${groupId}`,
          id: `pickmix_${groupId}`,
          product_title: title,
          handle: '',
          variant_title: '',
          quantity: 1,
          url: '#',
          image: chrome.image || item.image,
          properties: {
            _pick_mix_parent: 'true',
            _pick_mix_id: groupId,
            _pick_mix_title: title,
            _pick_mix_which: item.properties._pick_mix_which || '',
            _pick_mix_image: chrome.image || '',
            _pick_mix_discount:
              item.properties._pick_mix_discount ||
              item.properties.pb_pick_mix_discount ||
              '0%'
          },
          isBundle: false,
          bundleNodes: [],
          isPickMixGroup: true,
          pickMixItems: [],
          pickMixLineIds: []
        };

        result.push(groups[groupId]);
      }

      groups[groupId].pickMixItems.push(item);
      groups[groupId].pickMixLineIds.push(item.key);
    });

    Object.values(groups).forEach((group) => {
      const children = group.pickMixItems || [];

      const originalTotal = children.reduce((sum, item) => {
        return sum + (Number(item.original_line_price) || 0);
      }, 0);

      // Wat de klant van deze bundel betaalt: zonder de SMYLE-cadeaus en zonder de
      // stuks die gratis zijn bij een elektrische tandenborstel. Die laatste
      // kunnen een deel van een regel zijn, dus er wordt naar rato gerekend.
      const paidShare = (item, field) => {
        const quantity = Number(item.quantity) || 0;
        const total = Number(item[field]) || 0;

        if (item.properties?._pick_mix_smyle_gift === 'true' || quantity <= 0) return 0;

        const free = Math.min(
          quantity,
          Math.max(0, Number(item.properties?._pick_mix_free_qty || 0))
        );

        if (free <= 0) return total;

        return Math.round((total / quantity) * (quantity - free));
      };

      const paidOriginalTotal = children.reduce((sum, item) => {
        return sum + paidShare(item, 'original_line_price');
      }, 0);

      const realFinalTotal = children.reduce((sum, item) => {
        return sum + paidShare(item, 'final_line_price');
      }, 0);

      const totalQty = children.reduce((sum, item) => {
        return sum + (Number(item.quantity) || 0);
      }, 0);

      const discountPercent = parseDiscountPercent(group.properties._pick_mix_discount);

      // Giftbags (`_pick_mix_no_discount`) get no Pick & Mix
      // discount, as on the page and in the discount function.
      const noDiscountTotal = children.reduce((sum, item) => {
        return item.properties?._pick_mix_no_discount === 'true'
          ? sum + paidShare(item, 'original_line_price')
          : sum;
      }, 0);

      const visualFinalTotal = discountPercent > 0
        ? Math.round((paidOriginalTotal - noDiscountTotal) * (100 - discountPercent) / 100) + noDiscountTotal
        : realFinalTotal;

      group.quantity = totalQty;
      group.pickMixCount = totalQty;
      group.original_line_price = originalTotal;
      group.final_line_price = USE_VISUAL_PICK_MIX_DISCOUNT ? visualFinalTotal : realFinalTotal;

      if (!group.image && children[0]?.image) {
        group.image = children[0].image;
      }
    });

    return result;
  }

  function isMarathonLine(item) {
    if (!item?.properties) return false;

    // Heeft de cart transform hier al één bundelregel van gemaakt, dan niet
    // opnieuw groeperen — dan wikkel je een bundel in een bundel.
    if (isMarathonMergedLine(item)) return false;

    return item.properties._marathon_bundle === 'true' &&
      Boolean(item.properties._marathon_bundle_id);
  }

  /**
   * De samengevoegde parent-regel: draagt de bundel-attributes die de cart
   * transform opnieuw stempelt, en heeft componenten. Zonder actieve transform
   * bestaat deze niet en komen de losse regels binnen.
   */
  function isMarathonMergedLine(item) {
    return item?.properties?._marathon_bundle === 'true' &&
      Array.isArray(item.mergedComponents) &&
      item.mergedComponents.length > 0;
  }

  function groupMarathonLines(items) {
    const result = [];
    const groups = Object.create(null);

    for (const item of items) {
      // Al samengevoegd: hergebruik de marathon-weergave, maar met de
      // componenten van Shopify als kinderen in plaats van losse cart-regels.
      if (isMarathonMergedLine(item)) {
        result.push({
          ...item,
          product_title: decodeHtml(
            item.properties._marathon_bundle_title ||
              item.product_title ||
              'Marathonpakket'
          ),
          isMarathonGroup: true,
          marathonItems: item.mergedComponents,
          // Eén regel verwijderen haalt de hele bundel weg.
          marathonLineIds: [item.key],
          quantity: item.mergedComponents.reduce((sum, c) => {
            return sum + (Number(c.quantity) || 0);
          }, 0)
        });
        continue;
      }

      if (!isMarathonLine(item)) {
        result.push(item);
        continue;
      }

      const bundleId = item.properties._marathon_bundle_id;

      if (!groups[bundleId]) {
        groups[bundleId] = {
          key: `marathon_${bundleId}`,
          id: `marathon_${bundleId}`,
          product_title: decodeHtml(
            item.properties._marathon_bundle_title || 'Marathonpakket'
          ),
          handle: '',
          variant_title: '',
          quantity: 0,
          url: '#',
          image: item.properties._marathon_bundle_image || item.image,
          properties: {
            _marathon_bundle: 'true',
            _marathon_bundle_id: bundleId,
            _marathon_bundle_title:
              item.properties._marathon_bundle_title || 'Marathonpakket'
          },
          isBundle: false,
          isMarathonGroup: true,
          marathonItems: [],
          marathonLineIds: [],
          original_line_price: 0,
          final_line_price: 0
        };

        result.push(groups[bundleId]);
      }

      const group = groups[bundleId];
      const lineOriginal = Number(item.original_line_price) || Number(item.final_line_price) || 0;
      const lineFinal = Number(item.final_line_price) || 0;

      group.marathonItems.push(item);
      group.marathonLineIds.push(item.key);
      group.quantity += Number(item.quantity) || 0;
      // Alle bundelregels tellen mee, boosters incluis. De 42,195% van de
      // kortingsapp zit al in final_line_price, dus dit is wat de klant écht
      // betaalt. Boosters overslaan gaf een cart-totaal dat honderden centen
      // lager was dan de checkout.
      //
      // De boosters staan hieronder in de weergave wél als "gratis" — dat is een
      // label, geen berekening. Haal ze hier niet opnieuw uit de som.
      group.original_line_price += lineOriginal;
      group.final_line_price += lineFinal;

      if (!group.image && item.image) {
        group.image = item.image;
      }
    }

    return result;
  }

  function isMixMatchLine(item) {
    if (!item?.properties) return false;
    if (item.isMixMatchGroup || item.isPickMixGroup || item.isMarathonGroup) return false;

    // Heeft de cart transform hier al één bundelregel van gemaakt, dan niet
    // opnieuw groeperen — dan wikkel je een bundel in een bundel.
    if (isMixMatchMergedLine(item)) return false;

    return item.properties._powr_mixmatch === 'true' &&
      Boolean(item.properties._powr_mixmatch_id || item.properties._powr_mixmatch_product_id);
  }

  /**
   * De samengevoegde parent-regel: draagt de packattributen die de cart
   * transform opnieuw stempelt, en heeft componenten. Zonder actieve transform
   * bestaat deze niet en komen de losse kleurregels binnen — de drawer werkt
   * beide af, net als bij de marathonbundel.
   */
  function isMixMatchMergedLine(item) {
    return item?.properties?._powr_mixmatch === 'true' &&
      Array.isArray(item.mergedComponents) &&
      item.mergedComponents.length > 0;
  }

  /**
   * PDP v4 pakket, merged by the discount app's cart transform into one line on
   * the hidden "POWR Pakket" product (variant Wasstrips or Liquid). Shown with the
   * marathon layout: its components as children, the free boosters (marked
   * `_pakket_gift` by assets/pdp-v4.js) struck through as GRATIS. A pakket the
   * transform did not merge (incomplete) stays as loose lines.
   * The POWR ontdekbundel (`_pb_ontdekbundel`, assets/powr-ontdek.js) merges the
   * same way onto "POWR Ontdekbundel" and uses this layout too, without gifts.
   */
  function groupPakketLines(items) {
    return items.map((item) => {
      const isOntdek = Boolean(item?.properties?._pb_ontdekbundel);
      if (!(item?.properties?._pakket || isOntdek) || !item.mergedComponents?.length) return item;
      return {
        ...item,
        product_title:
          !isOntdek && item.variant_title ? `POWR ${item.variant_title} Pakket` : item.product_title,
        isMarathonGroup: true,
        marathonItems: item.mergedComponents.map((child) => {
          const isGift = child.properties?._pakket_gift === 'true';
          return {
            ...child,
            properties: {
              ...child.properties,
              // The ontdekbundel's product titles already name the wash type.
              _marathon_bundle_format: isGift || isOntdek ? '' : child.variant_title,
              _marathon_bundle_gift: isGift ? 'true' : '',
            },
          };
        }),
        // Removing the merged line removes the whole pakket.
        marathonLineIds: [item.key],
        quantity: item.mergedComponents.reduce((sum, child) => sum + (Number(child.quantity) || 0), 0),
      };
    });
  }

  function groupMixMatchLines(items) {
    const result = [];
    const groups = Object.create(null);

    for (const item of items) {
      // Al samengevoegd: hergebruik de mix & match weergave, maar met de
      // componenten van Shopify als kinderen in plaats van losse cart-regels.
      if (isMixMatchMergedLine(item)) {
        result.push({
          ...item,
          product_title: decodeHtml(
            item.properties._powr_mixmatch_title ||
              item.product_title ||
              'Mix & Match'
          ),
          url: item.properties._powr_mixmatch_edit_url || item.url || '#',
          isMixMatchGroup: true,
          mixMatchItems: item.mergedComponents,
          // Eén regel verwijderen haalt de hele bundel weg.
          mixMatchLineIds: [item.key],
          quantity: item.mergedComponents.reduce((sum, child) => {
            return sum + (Number(child.quantity) || 0);
          }, 0)
        });
        continue;
      }

      if (!isMixMatchLine(item)) {
        result.push(item);
        continue;
      }

      const groupId =
        item.properties._powr_mixmatch_id ||
        `product_${item.properties._powr_mixmatch_product_id || 'unknown'}`;
      const title = decodeHtml(
        item.properties._powr_mixmatch_title || item.product_title || 'Mix & Match'
      );

      if (!groups[groupId]) {
        groups[groupId] = {
          key: `mixmatch_${groupId}`,
          id: `mixmatch_${groupId}`,
          product_title: title,
          handle: '',
          variant_title: '',
          quantity: 0,
          url: item.properties._powr_mixmatch_edit_url || '#',
          image: item.properties._powr_mixmatch_image || item.image,
          properties: {
            _powr_mixmatch: 'true',
            _powr_mixmatch_id: groupId,
            _powr_mixmatch_product_id: item.properties._powr_mixmatch_product_id || '',
            _powr_mixmatch_title: title,
            _powr_mixmatch_image: item.properties._powr_mixmatch_image || '',
            _powr_mixmatch_tier: item.properties._powr_mixmatch_tier || '',
            _powr_mixmatch_edit_url: item.properties._powr_mixmatch_edit_url || '',
            _powr_mixmatch_price: item.properties._powr_mixmatch_price || '',
            _powr_mixmatch_compare_at: item.properties._powr_mixmatch_compare_at || '',
          },
          isBundle: false,
          isMixMatchGroup: true,
          mixMatchItems: [],
          mixMatchLineIds: [],
          original_line_price: 0,
          final_line_price: 0,
        };

        result.push(groups[groupId]);
      }

      const group = groups[groupId];
      const lineOriginal = Number(item.original_line_price) || Number(item.final_line_price) || 0;
      const lineFinal = Number(item.final_line_price) || 0;

      group.mixMatchItems.push(item);
      group.mixMatchLineIds.push(item.key);
      group.quantity += Number(item.quantity) || 0;
      group.original_line_price += lineOriginal;
      group.final_line_price += lineFinal;

      if (!group.image && item.image) {
        group.image = item.image;
      }
    }

    Object.values(groups).forEach((group) => {
      const packCompare = Number(group.properties?._powr_mixmatch_compare_at || 0);
      const packPrice = Number(group.properties?._powr_mixmatch_price || 0);

      // PDP pack prices win so cart matches the summary bar (dummy tier + list×N),
      // instead of whatever the colour SKUs currently sell for on sale.
      if (packCompare > 0) group.original_line_price = packCompare;
      if (packPrice > 0) group.final_line_price = packPrice;
    });

    return result;
  }

  async function removePickMixGroup(lineIds) {
    const ids = [...new Set((Array.isArray(lineIds) ? lineIds : []).filter(Boolean))];

    if (!ids.length) return fetchCart();

    if (window.PBCart && typeof PBCart.removeLines === 'function') {
      const cart = await PBCart.removeLines(ids);
      return normalizeCart(cart);
    }

    console.warn('[UCD][lines] PBCart.removeLines missing. Falling back to one-by-one remove.');

    let cart = null;

    for (const lineId of ids) {
      cart = await PBCart.removeLine(lineId);
    }

    if (cart) return normalizeCart(cart);
    return fetchCart();
  }

  function normalizeCart(gqlCart) {
    cartCurrency =
      gqlCart.cost?.totalAmount?.currencyCode ||
      gqlCart.cost?.subtotalAmount?.currencyCode ||
      gqlCart.lines?.edges?.[0]?.node?.merchandise?.price?.currencyCode ||
      'EUR';

    const rawItems = (gqlCart.lines?.edges || []).map((e) => {
      const n = e.node;
      const merch = n.merchandise;
      const product = merch?.product || {};
      const attrs = Object.fromEntries((n.attributes || []).map((a) => [a.key, a.value]));

      const productTitleLower = String(product.title || '').trim().toLowerCase();

      const isBundle = merch?.requiresComponents === true;
      const bundleNodes = merch?.components?.nodes || [];

      // Componenten van een cart-transform merge. Los van bundleNodes: die zijn
      // van een native Shopify bundle (requiresComponents), deze van een
      // samengevoegde regel. Onze Marathonpakket-parent is geen native bundle,
      // dus isBundle blijft false en alleen dit vult zich.
      const mergedComponents = (n.lineComponents || []).map((c) => {
        const cMerch = c.merchandise || {};
        const cAttrs = Object.fromEntries(
          (c.attributes || []).map((a) => [a.key, a.value])
        );

        return {
          key: c.id,
          quantity: Number(c.quantity) || 1,
          product_title: cMerch.product?.title || cMerch.title || '',
          variant_title: cMerch.title || '',
          image: cMerch.image?.url || '',
          url: cMerch.product?.handle ? `/products/${cMerch.product.handle}` : '#',
          properties: cAttrs,
          original_line_price: Math.round(
            parseFloat(c.cost?.subtotalAmount?.amount || 0) * 100
          ),
          final_line_price: Math.round(
            parseFloat(c.cost?.totalAmount?.amount || 0) * 100
          ),
        };
      });

      const isPickMixTransformedLine = isPickMixBundleProductLine(productTitleLower, attrs);

      const pickMixBundleId =
        attrs._pick_mix_id ||
        attrs.pb_pick_mix_id ||
        '';

      let pickMixDisplayItems = isPickMixTransformedLine
        ? getPickMixDisplayItems(pickMixBundleId)
        : [];

      if (isPickMixTransformedLine) {
        pickMixDisplayItems = enrichPickMixDisplayItems(pickMixDisplayItems, bundleNodes);
      }

      const unitPrice = Math.round(parseFloat(merch?.price?.amount || 0) * 100);
      const compareAtCents = Math.round(parseFloat(merch?.compareAtPrice?.amount || 0) * 100);
      const unitOriginal = compareAtCents > unitPrice ? compareAtCents : unitPrice;
      const before = unitOriginal * n.quantity;

      const discount = Array.isArray(n.discountAllocations)
        ? n.discountAllocations.reduce((sum, da) => {
            return sum + Math.round(parseFloat(da.discountedAmount?.amount || 0) * 100);
          }, 0)
        : 0;

      const apiBefore = Math.round(parseFloat(n.cost?.subtotalAmount?.amount || 0) * 100);
      const after = Math.round(parseFloat(n.cost?.totalAmount?.amount || 0) * 100);
      const lineBefore = Math.max(before, apiBefore);
      const lineAfter = after > 0 ? after : Math.max(0, lineBefore - discount);

      const pickMixChrome = isPickMixTransformedLine
        ? getPickMixChrome(pickMixBundleId, attrs)
        : { title: '', image: '' };

      const cartDisplay = isPickMixTransformedLine
        ? {
            title: pickMixChrome.title || 'Pick & Mix',
            subtitle: '',
          }
        : resolveCartLineDisplay(product, merch?.title);

      return {
        key: n.id,
        id: merch?.id,

        product_title: cartDisplay.title,

        subtitle: cartDisplay.subtitle,

        handle: isPickMixTransformedLine ? '' : product.handle,
        variant_title: merch?.title || '',
        quantity: n.quantity,

        final_line_price: lineAfter,
        original_line_price: lineBefore,

        url: isPickMixTransformedLine ? '#' : `/products/${product.handle || ''}`,
        image:
          pickMixChrome.image ||
          merch?.image?.url ||
          pickMixDisplayItems[0]?.image ||
          mergedComponents[0]?.image ||
          '',
        properties: attrs,

        isBundle,
      mergedComponents,
      bundleNodes,
      isPickMixTransformedLine,
      pickMixBundleId,
      editUrl: isPickMixTransformedLine ? getPickMixEditUrl(pickMixBundleId) : '',
      pickMixItems: pickMixDisplayItems,
      pickMixCount: pickMixDisplayItems.reduce((sum, item) => {
        return sum + (Number(item.quantity) || 0);
      }, 0)
      };
    });

    const items = groupPakketLines(groupMixMatchLines(groupMarathonLines(groupPickMixLines(rawItems))));

    // Newest line on top: assign a stable, monotonically increasing sequence the
    // first time we see a line id (in cart edge order), then sort descending.
    // New lines (never seen before) always get the highest sequence -> top.
    items.forEach((it) => orderSeqFor(it.key));
    items.sort((a, b) => orderSeqFor(b.key) - orderSeqFor(a.key));

    const original_total_price = items.reduce((s, it) => {
      return s + (Number(it.original_line_price) || 0);
    }, 0);

    const visual_total_price = items.reduce((s, it) => {
      return s + (Number(it.final_line_price) || 0);
    }, 0);

    // Order-level discount codes sit on the cart, not on a line, so the line totals above
    // miss them: the drawer showed the price before the code while checkout took it off.
    // Only code allocations: automatic ones (Pick & Mix) are already in the visual totals.
    const codeAllocations = (gqlCart.discountAllocations || []).filter((da) => da.code);
    const codeDiscount = codeAllocations.reduce((sum, da) => {
      return sum + Math.round(parseFloat(da.discountedAmount?.amount || 0) * 100);
    }, 0);

    return {
      items,
      currency: cartCurrency,
      item_count: items.reduce((sum, it) => sum + (Number(it.quantity) || 0), 0),
      total_price:
        (USE_VISUAL_PICK_MIX_DISCOUNT
          ? visual_total_price
          : Math.round(parseFloat(gqlCart.cost?.subtotalAmount?.amount || 0) * 100)) - codeDiscount,
      original_total_price,
      discount_codes: [...new Set(codeAllocations.map((da) => da.code))]
    };
  }

  function fetchCart() {
    return PBCart.current().then(normalizeCart);
  }

  function changeLine(lineId, quantity) {
    if (quantity <= 0) return PBCart.removeLine(lineId).then(normalizeCart);
    return PBCart.updateLine(lineId, quantity).then(normalizeCart);
  }

  function withWidthParam(src, w) {
    if (!src) return '';
    const join = src.includes('?') ? '&' : '?';
    return `${src}${join}width=${w}`;
  }

  function isMeaningfulVariantTitle(t) {
    const s = String(t || '').trim();
    if (!s) return false;
    if (s.toLowerCase() === 'default title') return false;
    return true;
  }

  function metafieldValue(mf) {
    return String(mf?.value || '').trim();
  }

  /**
   * Resolve cart line title + subtitle from custom.cart_naming rules.
   * @see custom.cart_naming values: bar | accessoire | skincare | bundle | liquid | powr
   */
  function resolveCartLineDisplay(product, variantTitle) {
    const nativeTitle = String(product?.title || '').trim();
    const cardTitle = metafieldValue(product?.cardTitle);
    const productSubtitle = metafieldValue(product?.subtitle);
    const ratingFor = metafieldValue(product?.ratingFor);
    const naming = metafieldValue(product?.cartNaming).toLowerCase();
    const selectedVariant = isMeaningfulVariantTitle(variantTitle)
      ? String(variantTitle).trim()
      : '';

    switch (naming) {
      case 'bar':
        return {
          title: ratingFor || nativeTitle,
          subtitle: productSubtitle,
        };
      case 'accessoire':
        return {
          title: cardTitle || nativeTitle,
          // Subtitle comes from collection_page_rating_for, but only the selected variant label (e.g. "Pink").
          subtitle: selectedVariant || ratingFor,
        };
      case 'skincare':
      case 'bundle':
      case 'liquid':
      case 'powr':
        return {
          title: cardTitle || nativeTitle,
          subtitle: productSubtitle,
        };
      default:
        return {
          title: cardTitle || nativeTitle,
          subtitle: productSubtitle,
        };
    }
  }

  function getPickMixBundleVariantLabel(child) {
    const variantCandidates = [
      child?.variantTitle,
      child?.variant_title,
      child?.properties?._pick_mix_variant_title,
      child?.properties?.pb_pick_mix_variant_title
    ];

    for (const candidate of variantCandidates) {
      if (isMeaningfulVariantTitle(candidate)) {
        return String(candidate).trim();
      }
    }

    return String(
      child?.subtitle ||
      child?.properties?._pick_mix_subtitle ||
      child?.properties?.pb_pick_mix_subtitle ||
      ''
    ).trim();
  }

  function getPickMixChildProductTitle(child) {
    const cardTitle =
      child?.properties?._pick_mix_card_title ||
      child?.properties?.pb_pick_mix_card_title ||
      '';

    if (cardTitle) return decodeHtml(cardTitle);

    return child?.title || child?.product_title || 'Item';
  }

  function isPickMixBundleProductLine(productTitleLower, attrs) {
    const hasPickMixAttrs = Boolean(
      attrs?._pick_mix_id ||
      attrs?.pb_pick_mix_id ||
      attrs?._pick_mix === 'true' ||
      attrs?.pb_pick_mix === 'true'
    );

    if (hasPickMixAttrs) return true;

    return (
      productTitleLower === 'pick & mix' ||
      productTitleLower === 'pick & mix bundle' ||
      productTitleLower.includes('pick & mix')
    );
  }

  // "Gratis" onder een bundelregel: voor de SMYLE-cadeaus (hele regel) en voor de
  // tandpasta die gratis is bij een elektrische tandenborstel — die kan ook maar
  // voor een deel van de regel gelden, bijvoorbeeld drie tubes bij één borstel.
  function pickMixGiftLabel(child) {
    if (child?.isGift || child?.properties?._pick_mix_smyle_gift === 'true') {
      return `<div class="ucd-bundle-variant ucd-bundle-free">Gratis</div>`;
    }

    const quantity = Number(child?.quantity) || 0;
    const free = Math.min(
      quantity,
      Math.max(0, Number(child?.freeQty ?? child?.properties?._pick_mix_free_qty ?? 0))
    );

    if (free <= 0) return '';

    return free >= quantity
      ? `<div class="ucd-bundle-variant ucd-bundle-free">Gratis</div>`
      : `<div class="ucd-bundle-variant ucd-bundle-free">${free}\u00d7 gratis</div>`;
  }

  function buildPickMixDisplayFromBundleNodes(bundleNodes) {
    return (bundleNodes || []).map((node) => {
      const pv = node?.productVariant || {};
      const variantGid = String(pv?.id || '');
      const variantId = variantGid.includes('/') ? variantGid.split('/').pop() : variantGid;

      return {
        variantId,
        id: variantId,
        title: pv?.product?.title || 'Item',
        variantTitle: pv?.title || '',
        variant_title: pv?.title || '',
        quantity: Math.max(1, Number(node?.quantity || 1)),
        image: pv?.image?.url || '',
        url: pv?.product?.handle ? `/products/${pv.product.handle}` : '#'
      };
    });
  }

  function enrichPickMixDisplayItems(displayItems, bundleNodes) {
    const items = Array.isArray(displayItems) ? displayItems : [];
    const nodes = Array.isArray(bundleNodes) ? bundleNodes : [];

    if (!items.length) {
      return buildPickMixDisplayFromBundleNodes(nodes);
    }

    if (!nodes.length) return items;

    return items.map((displayItem) => {
      if (isMeaningfulVariantTitle(displayItem?.variantTitle || displayItem?.variant_title)) {
        return displayItem;
      }

      const displayVariantId = String(displayItem?.variantId || displayItem?.id || '').replace(/\D/g, '');
      const match = nodes.find((node) => {
        const pv = node?.productVariant || {};
        const nodeVariantId = String(pv?.id || '').split('/').pop()?.replace(/\D/g, '') || '';
        return displayVariantId && nodeVariantId === displayVariantId;
      });

      if (!match) return displayItem;

      const pv = match.productVariant || {};
      const variantTitle = pv?.title || '';

      return {
        ...displayItem,
        variantTitle,
        variant_title: variantTitle
      };
    });
  }

  function bundleComponentsHTML(lineKey, bundleNodes, parentQty) {
    const nodes = Array.isArray(bundleNodes) ? bundleNodes : [];
    if (!nodes.length) return '';

    const count = nodes.length;
    const isOpen = bundleOpenByKey[lineKey] === true;

    const rows = nodes.map((c) => {
      const pv = c?.productVariant || {};
      const qtyEach = Number(c?.quantity || 1);
      const qty = qtyEach * Number(parentQty || 1);

      const productTitle = pv?.product?.title || 'Item';
      const variantTitle = pv?.title || '';
      const showVariant = isMeaningfulVariantTitle(variantTitle);

      const handle = pv?.product?.handle;
      const href = handle ? `/products/${handle}` : '#';

      const imgSrc = pv?.image?.url ? withWidthParam(pv.image.url, 96) : '';
      const imgAlt = pv?.image?.altText || productTitle;

      return `
        <div class="ucd-bundle-row">
          <div class="ucd-bundle-qty">${qty} ×</div>

          <a class="ucd-bundle-thumb" href="${href}" aria-label="${escapeAttr(productTitle)}">
            ${imgSrc ? `<img class="ucd-bundle-img" src="${imgSrc}" alt="${escapeAttr(imgAlt)}">` : ''}
          </a>

          <a class="ucd-bundle-link" href="${href}">
            <div class="ucd-bundle-text">
              <div class="ucd-bundle-product">${productTitle}</div>
              ${showVariant ? `<div class="ucd-bundle-variant">${variantTitle}</div>` : ``}
            </div>
          </a>
        </div>
      `;
    }).join('');

    return `
      <div class="ucd-bundle" data-linekey="${lineKey}">
        <button type="button"
          class="ucd-bundle-toggle"
          aria-expanded="${isOpen ? 'true' : 'false'}"
          data-count="${count}">
          <span class="ucd-bundle-toggle__label">${isOpen ? `Hide ${count} items` : `Show ${count} items`}</span>
          <span class="ucd-bundle-toggle__chev" aria-hidden="true">${isOpen ? '▴' : '▾'}</span>
        </button>

        <div class="ucd-bundle-items" style="display:${isOpen ? 'block' : 'none'};">
          ${rows}
        </div>
      </div>
    `;
  }

  function pickMixLineHTML(item) {
    const img = item.image ? withWidthParam(item.image, 240) : '';
    const title = item.product_title || 'Pick & Mix';
    const discount = item.properties?._pick_mix_discount || '';
    const discountAmount = Math.max(
      0,
      Number(item.original_line_price || 0) - Number(item.final_line_price || 0)
    );

    const children = item.pickMixItems || [];
    const count = Number(item.pickMixCount || 0);
    const isOpen = bundleOpenByKey[item.key] !== false;
    const lineIdsData = encodeJsonAttr(item.pickMixLineIds || []);

    const rows = children.map((child) => {
      const childImg = child.image ? withWidthParam(child.image, 96) : '';
      const productTitle = getPickMixChildProductTitle(child);
      const variantTitle = getPickMixBundleVariantLabel(child);
      const showVariant = Boolean(variantTitle);
      const href = child.url || '#';
      const giftLabel = pickMixGiftLabel(child);

      return `
        <div class="ucd-bundle-row">
          <div class="ucd-bundle-qty">${child.quantity}×</div>

          <a class="ucd-bundle-thumb" href="${href}" aria-label="${escapeAttr(productTitle)}">
            ${childImg ? `<img class="ucd-bundle-img" src="${childImg}" alt="${escapeAttr(productTitle)}">` : ''}
          </a>

          <a class="ucd-bundle-link" href="${href}">
            <div class="ucd-bundle-text">
              <div class="ucd-bundle-product">${productTitle}</div>
              ${showVariant ? `<div class="ucd-bundle-variant">${variantTitle}</div>` : ``}
              ${giftLabel}
            </div>
          </a>
        </div>
      `;
    }).join('');

    return `
      <li class="ucd-line ucd-line--pickmix"
          data-key="${item.key}"
          data-pick-mix-group="true"
          data-pick-mix-line-ids="${lineIdsData}">
        <div class="ucd-media">
          ${
            img
              ? `<img src="${img}" alt="${escapeAttr(title)}">`
              : `<div style="width:100%;height:100%;background:#f5d7d7;border-radius:10px;"></div>`
          }
        </div>

        <div class="ucd-info">
          <a role="heading" aria-level="5" href="#" class="ucd-title">
            ${title.toUpperCase()}
          </a>

          ${discount ? `<div class="ucd-bundle-variant">${discount} korting</div>` : ``}
          ${discountAmount > 0 ? `<div class="ucd-bundle-variant">Korting: -${formatMoney(discountAmount)}</div>` : ``}

          <button type="button"
            class="ucd-bundle-toggle"
            aria-expanded="${isOpen ? 'true' : 'false'}"
            data-count="${count}">
            <span class="ucd-bundle-toggle__label">${isOpen ? `Hide ${count} items` : `Show ${count} items`}</span>
            <span class="ucd-bundle-toggle__chev" aria-hidden="true">${isOpen ? '▴' : '▾'}</span>
          </button>
        </div>

        <div class="ucd-price">
  <button type="button" aria-label="Remove ${escapeAttr(title)}" class="ucd-remove1">
    ${TRASH_SVG}
  </button>


          <div>
            ${
              Number(item.original_line_price) > Number(item.final_line_price)
                ? `<span class="ucd-money ucd-money--compare">${formatMoney(item.original_line_price)}</span>
                   <span class="ucd-money ucd-money--sale">${formatMoney(item.final_line_price)}</span>`
                : `<span class="ucd-money">${formatMoney(item.final_line_price)}</span>`
            }
          </div>
        </div>

        <div class="ucd-bundle" data-linekey="${item.key}">
          <div class="ucd-bundle-items" style="display:${isOpen ? 'block' : 'none'};">
            ${rows}
          </div>
        </div>
      </li>
    `;
  }

  function marathonLineHTML(item) {
    const image = item.image ? withWidthParam(item.image, 240) : '';
    const title = item.product_title || 'Marathonpakket';
    const children = item.marathonItems || [];
    const count = children.reduce((sum, child) => {
      return sum + (Number(child.quantity) || 0);
    }, 0);
    const isOpen = bundleOpenByKey[item.key] !== false;
    const lineIdsData = encodeJsonAttr(item.marathonLineIds || []);

    const rows = children.map((child) => {
      const childImage = child.image ? withWidthParam(child.image, 96) : '';
      const productTitle =
        child.properties?._marathon_bundle_item_title ||
        child.product_title ||
        'Item';
      const format = child.properties?._marathon_bundle_format || '';
      const isGift = child.properties?._marathon_bundle_gift === 'true';
      const href = child.url || '#';
      const childOriginal = Number(child.original_line_price) || Number(child.final_line_price) || 0;

      return `
        <div class="ucd-bundle-row">
          <div class="ucd-bundle-qty">${child.quantity}×</div>
          <a class="ucd-bundle-thumb" href="${href}" aria-label="${escapeAttr(productTitle)}">
            ${childImage ? `<img class="ucd-bundle-img" src="${childImage}" alt="${escapeAttr(productTitle)}">` : ''}
          </a>
          <a class="ucd-bundle-link" href="${href}">
            <div class="ucd-bundle-text">
              <div class="ucd-bundle-product">${escapeAttr(decodeHtml(productTitle))}</div>
              ${format ? `<div class="ucd-bundle-variant">${escapeAttr(format)}${isGift ? ' · Gratis' : ''}</div>` : ''}
              ${
                // Alleen de boosters krijgen een prijsregel, en die is bewust "gratis":
                // de bundelkorting is groter dan hun waarde, dus zo framen we het.
                // De was-producten krijgen géén prijs — de klant ziet alleen het
                // bundeltotaal, en dat is het echte bedrag uit de checkout.
                isGift
                  ? `<div class="ucd-bundle-variant"><s>${formatMoney(childOriginal)}</s> GRATIS</div>`
                  : ''
              }
            </div>
          </a>
        </div>
      `;
    }).join('');

    return `
      <li class="ucd-line ucd-line--marathon"
          data-key="${item.key}"
          data-marathon-group="true"
          data-marathon-line-ids="${lineIdsData}">
        <div class="ucd-media">
          ${image ? `<img src="${image}" alt="${escapeAttr(title)}">` : ''}
        </div>
        <div class="ucd-info">
          <a role="heading" aria-level="5" href="#" class="ucd-title">
            ${escapeAttr(decodeHtml(title).toUpperCase())}
          </a>
          <button type="button"
            class="ucd-bundle-toggle"
            aria-expanded="${isOpen ? 'true' : 'false'}"
            data-count="${count}">
            <span class="ucd-bundle-toggle__label">${isOpen ? `Hide ${count} items` : `Show ${count} items`}</span>
            <span class="ucd-bundle-toggle__chev" aria-hidden="true">${isOpen ? '▴' : '▾'}</span>
          </button>

          <div class="ucd-pricerow">
            <div class="ucd-price">
              ${
                Number(item.original_line_price) > Number(item.final_line_price)
                  ? `<span class="ucd-money ucd-money--compare">${formatMoney(item.original_line_price)}</span>
                     <span class="ucd-money ucd-money--sale">${formatMoney(item.final_line_price)}</span>`
                  : `<span class="ucd-money">${formatMoney(item.final_line_price)}</span>`
              }
            </div>
          </div>
        </div>
        <div class="ucd-line-actions">
          <button type="button" aria-label="Remove ${escapeAttr(title)}" class="ucd-remove1">
            ${TRASH_SVG}
          </button>
        </div>
        <div class="ucd-bundle" data-linekey="${item.key}">
          <div class="ucd-bundle-items" style="display:${isOpen ? 'block' : 'none'};">
            ${rows}
          </div>
        </div>
      </li>
    `;
  }

  function mixMatchLineHTML(item) {
    const image = item.image ? withWidthParam(item.image, 240) : '';
    const title = item.product_title || 'Mix & Match';
    const children = item.mixMatchItems || [];
    const count = children.reduce((sum, child) => sum + (Number(child.quantity) || 0), 0);
    const isOpen = bundleOpenByKey[item.key] !== false;
    const lineIdsData = encodeJsonAttr(item.mixMatchLineIds || []);
    const editUrl = item.properties?._powr_mixmatch_edit_url || item.url || '';
    const tier = item.properties?._powr_mixmatch_tier || '';

    // Prefer pack prices stamped on ATC (dummy tier + single×N). Fall back to
    // summed colour line totals when properties are missing.
    const packCompare = Number(item.properties?._powr_mixmatch_compare_at || 0);
    const packPrice = Number(item.properties?._powr_mixmatch_price || 0);
    const displayCompare = packCompare > 0 ? packCompare : Number(item.original_line_price || 0);
    const displayFinal = packPrice > 0 ? packPrice : Number(item.final_line_price || 0);
    const showCompare = displayCompare > displayFinal;

    const rows = children.map((child) => {
      const childImage = child.image ? withWidthParam(child.image, 96) : '';
      const productTitle =
        child.properties?._powr_mixmatch_card_title ||
        child.product_title ||
        'Item';
      const href = child.url || '#';

      return `
        <div class="ucd-bundle-row">
          <div class="ucd-bundle-qty">${child.quantity}×</div>
          <a class="ucd-bundle-thumb" href="${href}" aria-label="${escapeAttr(productTitle)}">
            ${childImage ? `<img class="ucd-bundle-img" src="${childImage}" alt="${escapeAttr(productTitle)}">` : ''}
          </a>
          <a class="ucd-bundle-link" href="${href}">
            <div class="ucd-bundle-text">
              <div class="ucd-bundle-product">${escapeAttr(decodeHtml(productTitle))}</div>
            </div>
          </a>
        </div>
      `;
    }).join('');

    return `
      <li class="ucd-line ucd-line--mixmatch ucd-line--marathon"
          data-key="${item.key}"
          data-mixmatch-group="true"
          data-mixmatch-line-ids="${lineIdsData}">
        <div class="ucd-media">
          ${image ? `<img src="${image}" alt="${escapeAttr(title)}">` : ''}
        </div>
        <div class="ucd-info">
          <a role="heading" aria-level="5" href="${escapeAttr(editUrl || '#')}" class="ucd-title">
            ${escapeAttr(decodeHtml(title).toUpperCase())}
          </a>
          ${tier ? `<div class="ucd-bundle-variant">${escapeAttr(tier)} items</div>` : ''}
          <button type="button"
            class="ucd-bundle-toggle"
            aria-expanded="${isOpen ? 'true' : 'false'}"
            data-count="${count}">
            <span class="ucd-bundle-toggle__label">${isOpen ? `Hide ${count} items` : `Show ${count} items`}</span>
            <span class="ucd-bundle-toggle__chev" aria-hidden="true">${isOpen ? '▴' : '▾'}</span>
          </button>

          <div class="ucd-pricerow">
            <div class="ucd-price">
              ${
                showCompare
                  ? `<span class="ucd-money ucd-money--compare">${formatMoney(displayCompare)}</span>
                     <span class="ucd-money ucd-money--sale">${formatMoney(displayFinal)}</span>`
                  : `<span class="ucd-money">${formatMoney(displayFinal)}</span>`
              }
            </div>
          </div>
        </div>
        <div class="ucd-line-actions">
          ${editUrl ? `
            <a href="${escapeAttr(editUrl)}" class="ucd-edit-pickmix" aria-label="Edit Mix & Match">
              ✎
            </a>
          ` : ''}
          <button type="button" aria-label="Remove ${escapeAttr(title)}" class="ucd-remove1">
            ${TRASH_SVG}
          </button>
        </div>
        <div class="ucd-bundle" data-linekey="${item.key}">
          <div class="ucd-bundle-items" style="display:${isOpen ? 'block' : 'none'};">
            ${rows}
          </div>
        </div>
      </li>
    `;
  }

  function lineItemHTML(item) {
    if (item.isPickMixGroup) {
      return pickMixLineHTML(item);
    }

    if (item.isMarathonGroup) {
      return marathonLineHTML(item);
    }

    if (item.isMixMatchGroup) {
      return mixMatchLineHTML(item);
    }

    const img = item.image ? withWidthParam(item.image, 240) : '';
    const href = item.url || item.handle ? (`/products/${item.handle || ''}`) : '#';
    const isGift = isGiftItem(item);
    const isPickMixCartLine =
      item.isPickMixTransformedLine === true ||
      item.isPickMixGroup === true ||
      item.properties?._pick_mix === 'true' ||
      item.properties?.pb_pick_mix === 'true' ||
      String(item.product_title || '').toLowerCase().includes('pick & mix');

    // Free gifts and the free POWR ontdekfunnel sample (`_pb_sample`, assets/powr-ontdek.js):
    // qty is fixed at 1 — hide stepper (Figma / ticket)
    const hideQtyControls = isPickMixCartLine || isGift || item.properties?._pb_sample === 'true';
    const editUrl = item.isPickMixTransformedLine
  ? (item.editUrl || getPickMixEditUrl(item.pickMixBundleId))
  : '';

    const pickMixDiscount =
      item.properties?._pick_mix_discount ||
      item.properties?.pb_pick_mix_discount ||
      '';

    let bundleToggleHtml = '';
    let bundleItemsHtml = '';

    if (item.isPickMixTransformedLine && item.pickMixItems?.length) {
      const count = item.pickMixCount || item.pickMixItems.length;
      const isOpen = bundleOpenByKey[item.key] !== false;

      const rows = item.pickMixItems.map((child) => {
        const childImg = child.image ? withWidthParam(child.image, 96) : '';
        const productTitle = getPickMixChildProductTitle(child);
        const variantTitle = getPickMixBundleVariantLabel(child);
        const href = child.url || '#';
        const giftLabel = pickMixGiftLabel(child);

        return `
          <div class="ucd-bundle-row">
            <div class="ucd-bundle-qty">${child.quantity}×</div>

            <a class="ucd-bundle-thumb" href="${href}" aria-label="${escapeAttr(productTitle)}">
              ${childImg ? `<img class="ucd-bundle-img" src="${childImg}" alt="${escapeAttr(productTitle)}">` : ''}
            </a>

            <a class="ucd-bundle-link" href="${href}">
              <div class="ucd-bundle-text">
                <div class="ucd-bundle-product">${productTitle}</div>
                ${variantTitle ? `<div class="ucd-bundle-variant">${variantTitle}</div>` : ``}
                ${giftLabel}
              </div>
            </a>
          </div>
        `;
      }).join('');

      bundleToggleHtml = `
        <button type="button"
          class="ucd-bundle-toggle"
          aria-expanded="${isOpen ? 'true' : 'false'}"
          data-count="${count}">
          <span class="ucd-bundle-toggle__label">${isOpen ? `Hide ${count} items` : `Show ${count} items`}</span>
          <span class="ucd-bundle-toggle__chev" aria-hidden="true">${isOpen ? '▴' : '▾'}</span>
        </button>
      `;

      bundleItemsHtml = `
        <div class="ucd-bundle" data-linekey="${item.key}">
          <div class="ucd-bundle-items" style="display:${isOpen ? 'block' : 'none'};">
            ${rows}
          </div>
        </div>
      `;
    } else if (item.isBundle) {
      const bundleHTML = bundleComponentsHTML(item.key, item.bundleNodes, item.quantity);

      const temp = document.createElement('div');
      temp.innerHTML = bundleHTML;

      const bundle = temp.querySelector('.ucd-bundle');
      const toggle = bundle?.querySelector('.ucd-bundle-toggle');
      const items = bundle?.querySelector('.ucd-bundle-items');

      if (toggle) bundleToggleHtml = toggle.outerHTML;
      if (items) {
        bundleItemsHtml = `
          <div class="ucd-bundle" data-linekey="${item.key}">
            ${items.outerHTML}
          </div>
        `;
      }
    }

    const displayTitle = String(item.product_title || '').replace(/\s*\|\s*/g, ' ').trim();
    const subtitle = String(item.subtitle || '').trim();

    const giftBadgeLabel = isGift ? getGiftBadgeLabel(item) : '';

    return `
      <li class="ucd-line ${item.isPickMixTransformedLine ? 'ucd-line--pickmix-transformed' : ''}${isGift ? ' ucd-line--gift' : ''}" data-key="${item.key}"${isGift ? ' data-is-gift="true"' : ''}>
        <div class="ucd-media">
          ${isGift ? `<span class="ucd-gift-badge">${escapeHtml(giftBadgeLabel)}</span>` : ''}
          ${
            img
              ? `<a href="${href}" aria-label="View details for ${escapeAttr(item.product_title)}">
                  <img src="${img}" alt="${escapeAttr(item.product_title)}">
                </a>`
              : ''
          }
        </div>

        <div class="ucd-info">
          <div class="ucd-titlewrap">
            <a role="heading" aria-level="5" href="${href}" class="ucd-title">
              ${escapeHtml(displayTitle)}
            </a>

            ${subtitle ? `<div class="ucd-subtitle">${subtitle}</div>` : ''}

            ${item.isPickMixTransformedLine && pickMixDiscount ? `<div class="ucd-bundle-variant">${pickMixDiscount} korting</div>` : ''}
          </div>

          <div class="ucd-pricerow">
            <div class="ucd-price">
              ${
                Number(item.original_line_price) > Number(item.final_line_price)
                  ? `<span class="ucd-money ucd-money--compare">${formatMoney(item.original_line_price)}</span>
                     <span class="ucd-money ucd-money--sale">${formatMoney(item.final_line_price)}</span>`
                  : `<span class="ucd-money">${formatMoney(item.final_line_price)}</span>`
              }
            </div>

            ${hideQtyControls ? '' : `
              <div class="ucd-qty">
                <button aria-label="Decrease quantity of ${escapeAttr(item.product_title)}" type="button" class="ucd-qty-btn" data-act="dec">−</button>
                <span class="ucd-qty-label">
                  <span class="sr-only">Quantity of ${item.product_title}</span>
                  <span class="ucd-qty-num">${item.quantity}</span>
                </span>
                <button aria-label="Increase quantity of ${escapeAttr(item.product_title)}" type="button" class="ucd-qty-btn" data-act="inc">＋</button>
              </div>
            `}
          </div>

          ${bundleToggleHtml}
        </div>

        <div class="ucd-line-actions">
          ${editUrl ? `
            <a href="${escapeAttr(editUrl)}" class="ucd-edit-pickmix" aria-label="Edit Pick & Mix">
              ✎
            </a>
          ` : ''}

          <button type="button" aria-label="Remove ${escapeAttr(item.product_title)}" class="ucd-remove1">
            ${TRASH_SVG}
          </button>
        </div>

        ${bundleItemsHtml}
      </li>
    `;
  }

  function bindEvents(cartItems) {
    const itemsByKey = new Map((cartItems || []).map((item) => [item.key, item]));

    list.querySelectorAll('.ucd-line').forEach((li) => {
      const key = li.dataset.key;
      const isPickMixGroup = li.dataset.pickMixGroup === 'true';
      const isMarathonGroup = li.dataset.marathonGroup === 'true';
      const isMixMatchGroup = li.dataset.mixmatchGroup === 'true';

      if (isPickMixGroup || isMarathonGroup || isMixMatchGroup) {
        li.querySelector('.ucd-remove1')?.addEventListener('click', () => {
          const encodedLineIds = isMarathonGroup
            ? li.dataset.marathonLineIds
            : isMixMatchGroup
              ? li.dataset.mixmatchLineIds
              : li.dataset.pickMixLineIds;
          const lineIds = decodeJsonAttr(encodedLineIds);

          lineSetLoading(li, true);

          removePickMixGroup(lineIds)
            .then((cart) => render(cart))
            .finally(() => lineSetLoading(li, false));
        });

        return;
      }

      li.querySelectorAll('.ucd-qty-btn').forEach((btn) => {
        const act = btn.dataset.act;

        btn.addEventListener('click', () => {
          const numEl = li.querySelector('.ucd-qty-num');
          const qtyNow = Number(numEl?.textContent || 1);
          const next = act === 'inc' ? qtyNow + 1 : Math.max(0, qtyNow - 1);
          if (next === qtyNow) return;

          numEl.textContent = String(next);

          // The optimistic write above put the DOM out of sync with lastSig. If
          // Shopify clamps the line (stock cap) the cart comes back unchanged, so
          // the signature still matches and render() would skip the repaint —
          // leaving the stepper showing a quantity the cart does not have.
          invalidateSignature();
          lineSetLoading(li, true);

          changeLine(key, next)
            .then((cart) => render(cart))
            .catch(() => {
              numEl.textContent = String(qtyNow);
            })
            .finally(() => lineSetLoading(li, false));
        });
      });

      li.querySelector('.ucd-remove1')?.addEventListener('click', () => {
        const item = itemsByKey.get(key);

        if (item && isGiftItem(item)) {
          suppressGiftReadd(item);
        }

        lineSetLoading(li, true);
        changeLine(key, 0)
          .then((cart) => render(cart))
          .finally(() => lineSetLoading(li, false));
      });
    });
  }

  let bundleToggleBound = false;

  function bindBundleToggles() {
    if (bundleToggleBound) return;
    if (!list) return;

    bundleToggleBound = true;

    list.addEventListener('click', (e) => {
      const btn = e.target?.closest?.('.ucd-bundle-toggle');
      if (!btn) return;

      const line = btn.closest('.ucd-line');
      if (!line) return;

      const bundleWrap = line.querySelector('.ucd-bundle');
      const panel = bundleWrap?.querySelector('.ucd-bundle-items');
      const lineKey = bundleWrap?.dataset?.linekey;

      if (!panel || !lineKey) return;

      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const next = !expanded;

      btn.setAttribute('aria-expanded', next ? 'true' : 'false');
      panel.style.display = next ? 'block' : 'none';

      bundleOpenByKey[lineKey] = next;

      const count = Number(btn.dataset.count || 0);
      const label = btn.querySelector('.ucd-bundle-toggle__label');
      const chev = btn.querySelector('.ucd-bundle-toggle__chev');

      if (label) label.textContent = next ? `Hide ${count} items` : `Show ${count} items`;
      if (chev) chev.textContent = next ? '▴' : '▾';
    });
  }

  function ensureGiftsMount() {
    let mount = document.getElementById('CartFreeGifts');

    if (!mount) {
      mount = document.createElement('div');
      mount.id = 'CartFreeGifts';
      mount.className = 'ucd-gift-banner-mount';
      mount.setAttribute('aria-live', 'polite');

      const content = drawer.querySelector('.ucd-content');
      if (content?.parentElement) {
        content.parentElement.insertBefore(mount, content);
      } else if (list?.parentElement) {
        list.parentElement.insertBefore(mount, list);
      }
    }

    return mount;
  }

  // --- Campaign gift card (Auto Gifter) ---
  //
  // While an Auto Gifter campaign is active the gift shows as a card at the top
  // of the drawer. Below the threshold it is UI only (never a cart line, so it
  // can never reach checkout); at or above it the embed adds the real line and
  // the card renders that line instead of the list. State comes from
  // window.autoGifter.state.gift and the `auto-gifter:state` event.

  const GIFT_LOCK_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false">
  <path d="M4.08333 6.41667H9.91667C10.561 6.41667 11.0833 6.939 11.0833 7.58333V11.0833C11.0833 11.7277 10.561 12.25 9.91667 12.25H4.08333C3.439 12.25 2.91667 11.7277 2.91667 11.0833V7.58333C2.91667 6.939 3.439 6.41667 4.08333 6.41667Z" stroke-width="1.28333" stroke="white"/>
  <path d="M4.66667 6.41667V4.66667C4.66667 4.04783 4.9125 3.45434 5.35008 3.01675C5.78767 2.57917 6.38116 2.33333 7 2.33333C7.61884 2.33333 8.21233 2.57917 8.64992 3.01675C9.0875 3.45434 9.33333 4.04783 9.33333 4.66667V6.41667" stroke-width="1.28333" stroke-linecap="round" stroke="white"/>
</svg>`;

  const giftVariantCache = new Map();
  let lastRenderedCart = null;

  function campaignGiftState() {
    return window.autoGifter?.state?.gift || null;
  }

  // The card is the first <li> of #CartLineItems, so it spaces like a cart line.
  // render() writes the empty mount with the list; renderGiftCard() fills it.
  const GIFT_CARD_MOUNT_HTML = '<li id="CartGiftCard" class="ucd-giftcard-mount" hidden></li>';
  let lockedGiftCardCache = { key: '', html: '' };

  function ensureGiftCardMount() {
    return list ? list.querySelector('#CartGiftCard') : null;
  }

  // The line the Auto Gifter embed placed (tagged _auto_gift). It always renders
  // in the card, even before the embed has published its state, so the line
  // never flashes in the list first.
  function findCampaignGiftLine(items) {
    const gift = campaignGiftState();

    return (items || []).find((item) => {
      const props = item?.properties || {};
      if (props._auto_gift !== 'true') return false;
      if (!gift?.giftId) return true;
      return props._gift_id === gift.giftId || props._pb_gift === gift.giftId;
    }) || null;
  }

  function hasPaidItems(items) {
    return (items || []).some((item) => !isGiftItem(item));
  }

  function formatMoneyShort(cents) {
    const value = Math.max(0, Number(cents) || 0);
    if (value % 100 !== 0) return formatMoney(value);

    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: cartCurrency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value / 100);
    } catch {
      return formatMoney(value);
    }
  }

  function giftSubtitle(variantTitle, fallback) {
    const base = isMeaningfulVariantTitle(variantTitle)
      ? String(variantTitle).trim()
      : String(fallback || '').trim();
    return base ? `${base} · gratis cadeau` : 'Gratis cadeau';
  }

  function loadGiftVariant(variantId) {
    const id = Number(variantId);
    if (!Number.isFinite(id) || id <= 0) return Promise.resolve(null);
    if (giftVariantCache.has(id)) return giftVariantCache.get(id);

    const cfg = window.PB_UNIFIED_CART || {};
    if (!cfg.endpoint || !cfg.token) return Promise.resolve(null);

    const query =
      'query($id:ID!){node(id:$id){... on ProductVariant{title image{url} ' +
      'price{amount currencyCode} compareAtPrice{amount} ' +
      'product{title handle featuredImage{url} ' +
      'cardTitle: metafield(namespace:"custom",key:"product_card_title"){value} ' +
      'subtitle: metafield(namespace:"custom",key:"product_subtitle"){value} ' +
      'ratingFor: metafield(namespace:"custom",key:"collection_page_rating_for"){value} ' +
      'cartNaming: metafield(namespace:"custom",key:"cart_naming"){value}}}}}';

    const promise = fetch(cfg.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': cfg.token
      },
      body: JSON.stringify({ query, variables: { id: `gid://shopify/ProductVariant/${id}` } })
    })
      .then((res) => res.json())
      .then((json) => {
        const node = json?.data?.node;
        if (!node) return null;

        const display = resolveCartLineDisplay(node.product, node.title);
        const price = Math.round(parseFloat(node.price?.amount || 0) * 100);
        const compareAt = Math.round(parseFloat(node.compareAtPrice?.amount || 0) * 100);

        return {
          title: display.title,
          subtitle: giftSubtitle(node.title, display.subtitle),
          image: node.image?.url || node.product?.featuredImage?.url || '',
          url: node.product?.handle ? `/products/${node.product.handle}` : '',
          unitPrice: Math.max(price, compareAt),
          currency: node.price?.currencyCode || ''
        };
      })
      .catch(() => {
        giftVariantCache.delete(id);
        return null;
      });

    giftVariantCache.set(id, promise);
    return promise;
  }

  function giftCardHTML({ locked, title, subtitle, image, url, originalCents, finalCents, remainingCents, subtotalCents, thresholdCents, removable }) {
    const img = image ? withWidthParam(image, 160) : '';
    const fill = locked && thresholdCents > 0
      ? Math.min(100, Math.max(0, (subtotalCents / thresholdCents) * 100))
      : 100;
    const thresholdLabel = thresholdCents > 0 ? formatMoneyShort(thresholdCents) : '';
    const titleHtml = url
      ? `<a class="ucd-giftcard__title" href="${escapeAttr(url)}">${escapeHtml(title)}</a>`
      : `<span class="ucd-giftcard__title">${escapeHtml(title)}</span>`;

    const labelsHtml = locked
      ? `<span class="ucd-giftcard__label">${escapeHtml(`${formatMoney(subtotalCents)} van ${thresholdLabel}`)}</span>
         <span class="ucd-giftcard__goal">${escapeHtml(`Gratis vanaf ${thresholdLabel}`)}</span>`
      : `<span class="ucd-giftcard__label">Cadeau ontgrendeld</span>
         ${thresholdLabel ? `<span class="ucd-giftcard__goal">${escapeHtml(thresholdLabel)} ✓</span>` : ''}`;

    return `
      <div class="ucd-giftcard ${locked ? 'is-locked' : 'is-unlocked'}" role="group" aria-label="${escapeAttr(locked ? 'Gratis cadeau, nog niet ontgrendeld' : 'Gratis cadeau ontgrendeld')}">
        <div class="ucd-giftcard__media">
          ${img ? `<img src="${escapeAttr(img)}" alt="" loading="lazy">` : ''}
          ${locked
            ? `<span class="ucd-giftcard__veil" aria-hidden="true"></span>
               <span class="ucd-giftcard__badge ucd-giftcard__badge--locked">${GIFT_LOCK_SVG}</span>`
            : `<span class="ucd-giftcard__badge ucd-giftcard__badge--free">GRATIS</span>`}
        </div>

        <div class="ucd-giftcard__info">
          <div class="ucd-giftcard__top">${titleHtml}</div>
          <div class="ucd-giftcard__subtitle">${escapeHtml(subtitle)}</div>

          <div class="ucd-giftcard__bottom">
            <div class="ucd-giftcard__price">
              ${originalCents > finalCents ? `<span class="ucd-giftcard__compare">${formatMoney(originalCents)}</span>` : ''}
              <span class="ucd-giftcard__free">${formatMoney(finalCents)}</span>
            </div>
            ${locked ? `<span class="ucd-giftcard__remaining">Nog ${formatMoney(remainingCents)}</span>` : ''}
          </div>

          <div class="ucd-giftcard__progress">
            <div class="ucd-giftcard__track" aria-hidden="true">
              <div class="ucd-giftcard__fill" style="width:${fill.toFixed(1)}%"></div>
            </div>
            <div class="ucd-giftcard__labels">${labelsHtml}</div>
          </div>
        </div>

        ${removable ? `
          <button type="button" aria-label="Verwijder ${escapeAttr(title)}" class="ucd-giftcard__remove">
            ${TRASH_SVG}
          </button>
        ` : ''}
      </div>
    `;
  }

  function hideGiftCard(mount) {
    if (!mount) return;
    mount.hidden = true;
    mount.innerHTML = '';
    delete mount.dataset.renderKey;
  }

  function renderUpsellTitle(gift, locked) {
    const titleEl = drawer.querySelector('#CartUpsellCard .ucd-upsell-title');
    if (!titleEl) return;

    if (titleEl.dataset.defaultTitle === undefined) {
      titleEl.dataset.defaultTitle = titleEl.textContent.trim();
    }

    if (locked && gift) {
      const label = String(gift.giftLabel || '').trim() || 'cadeau';
      const remaining = formatMoney(Math.round(Number(gift.remaining || 0) * 100));
      titleEl.textContent = `Nog ${remaining} voor je gratis ${label}`;
    } else {
      titleEl.textContent = titleEl.dataset.defaultTitle;
    }
  }

  function renderGiftCard(cart) {
    const mount = ensureGiftCardMount();
    const items = cart?.items || [];
    const gift = campaignGiftState();
    const line = findCampaignGiftLine(items);

    // Empty cart: no card (a bar at €0 looks off) and the default upsell title.
    if (!mount || !hasPaidItems(items)) {
      hideGiftCard(mount);
      renderUpsellTitle(null, false);
      return;
    }

    const thresholdCents = gift ? Math.round(Number(gift.threshold || 0) * 100) : 0;

    if (line) {
      renderUpsellTitle(gift, false);

      const html = giftCardHTML({
        locked: false,
        title: line.product_title || '',
        subtitle: giftSubtitle(line.variant_title, line.subtitle),
        image: line.image,
        url: line.url && line.url !== '/products/' ? line.url : '',
        originalCents: Number(line.original_line_price) || 0,
        finalCents: Number(line.final_line_price) || 0,
        remainingCents: 0,
        subtotalCents: 0,
        thresholdCents,
        removable: true
      });

      mount.dataset.renderKey = `line:${line.key}`;
      mount.innerHTML = html;
      mount.hidden = false;

      const card = mount.querySelector('.ucd-giftcard');
      mount.querySelector('.ucd-giftcard__remove')?.addEventListener('click', () => {
        suppressGiftReadd(line);
        card?.classList.add('is-loading');
        mount.querySelectorAll('button').forEach((btn) => { btn.disabled = true; });

        changeLine(line.key, 0)
          .then((next) => render(next))
          .catch(() => {
            card?.classList.remove('is-loading');
            mount.querySelectorAll('button').forEach((btn) => { btn.disabled = false; });
          });
      });
      return;
    }

    // Unlocked but not (yet) in the cart: removed by the shopper, or the embed
    // is still adding it. Nothing to show until the line lands.
    if (!gift || !gift.locked) {
      hideGiftCard(mount);
      renderUpsellTitle(gift, false);
      return;
    }

    renderUpsellTitle(gift, true);

    const renderKey = `locked:${gift.giftId}:${gift.variantId}`;
    mount.dataset.renderKey = renderKey;

    // render() rebuilds the list (and this mount) on every cart change. Paint the
    // last locked card straight away so it does not blink while the cached
    // variant lookup resolves.
    if (lockedGiftCardCache.key === renderKey && lockedGiftCardCache.html) {
      mount.innerHTML = lockedGiftCardCache.html;
      mount.hidden = false;
    }

    loadGiftVariant(gift.variantId).then((variant) => {
      // A newer render (or the line landing) took over while this loaded.
      if (mount.dataset.renderKey !== renderKey) return;

      const latest = campaignGiftState();
      if (!latest || !latest.locked || latest.giftId !== gift.giftId) return;

      const quantity = Math.max(1, Number(latest.quantity) || 1);
      const sameCurrency = !variant?.currency || variant.currency === cartCurrency;

      const html = giftCardHTML({
        locked: true,
        title: variant?.title || latest.productTitle || latest.title || 'Gratis cadeau',
        subtitle: variant?.subtitle || giftSubtitle(latest.variantTitle, ''),
        image: variant?.image || '',
        url: variant?.url || '',
        originalCents: sameCurrency ? (variant?.unitPrice || 0) * quantity : 0,
        finalCents: 0,
        remainingCents: Math.round(Number(latest.remaining || 0) * 100),
        subtotalCents: Math.round(Number(latest.subtotal || 0) * 100),
        thresholdCents: Math.round(Number(latest.threshold || 0) * 100),
        removable: false
      });

      lockedGiftCardCache = { key: renderKey, html };
      mount.innerHTML = html;
      mount.hidden = false;
    });
  }

  document.addEventListener('auto-gifter:state', () => {
    if (!lastRenderedCart) return;
    // The card decides which line leaves the list, so repaint both.
    invalidateSignature();
    render(lastRenderedCart);
  });

  let prevGiftKeys = new Set();
  let giftsBootstrapped = false;
  let giftBannerHideTimer = null;
  let giftBannerClearTimer = null;
  let pendingBannerGifts = null;
  let awaitingGiftAddedPopup = false;
  let giftPopupWaitTimer = null;

  function clearGiftBanner(mount) {
    if (!mount) return;

    mount.classList.remove('is-visible');
    clearTimeout(giftBannerClearTimer);

    giftBannerClearTimer = setTimeout(() => {
      mount.innerHTML = '';
      mount.hidden = true;
      mount.classList.remove('is-warning');
    }, 320);
  }

  // Shopify silently clamps a cart line to what it can still sell. Surface that in
  // the banner slot, otherwise the stepper just snaps back with no explanation.
  function showStockCapBanner(message) {
    const mount = ensureGiftsMount();
    if (!mount || !message) return;

    clearTimeout(giftBannerHideTimer);
    clearTimeout(giftBannerClearTimer);

    mount.hidden = false;
    mount.classList.add('is-warning');
    mount.classList.remove('is-visible');
    mount.innerHTML = `
      <div class="ucd-gift-banner" role="status">
        ${escapeHtml(message)}
      </div>
    `;

    // Force layout so the slide-down transition runs
    void mount.offsetHeight;
    mount.classList.add('is-visible');

    giftBannerHideTimer = setTimeout(() => {
      clearGiftBanner(mount);
    }, 4000);
  }

  function announceCartWarnings(warnings) {
    const stockWarning = (warnings || []).find(
      (w) => w?.code === 'MERCHANDISE_NOT_ENOUGH_STOCK'
    );

    if (!stockWarning) return;

    showStockCapBanner(
      stockWarning.message || 'Niet alle stuks konden worden toegevoegd.'
    );
  }

  function showGiftUnlockedBanner(gifts) {
    const mount = ensureGiftsMount();
    if (!mount || !gifts.length) return;

    const title = String(gifts[0].product_title || 'Gift')
      .replace(/\s*\|\s*/g, ' ')
      .trim();

    clearTimeout(giftBannerHideTimer);
    clearTimeout(giftBannerClearTimer);

    mount.hidden = false;
    mount.classList.remove('is-visible', 'is-warning');
    mount.innerHTML = `
      <div class="ucd-gift-banner" role="status">
        Free gift: ${escapeHtml(title)} 🎉
      </div>
    `;

    // Force layout so the slide-down transition runs
    void mount.offsetHeight;
    mount.classList.add('is-visible');

    giftBannerHideTimer = setTimeout(() => {
      clearGiftBanner(mount);
    }, 3200);
  }

  function isGiftAddedPopupOpen() {
    const popup = document.getElementById('PBGiftAddedPopup');
    return !!(popup && popup.classList.contains('pbg-popup--visible'));
  }

  function flushPendingGiftBanner() {
    if (!pendingBannerGifts?.length) return;
    if (awaitingGiftAddedPopup) return;

    const gifts = pendingBannerGifts;
    pendingBannerGifts = null;
    showGiftUnlockedBanner(gifts);
  }

  function queueGiftBanner(gifts) {
    pendingBannerGifts = gifts;
    clearTimeout(giftPopupWaitTimer);

    // Campaign add opens the cart first, then the pbga popup a tick later.
    // Wait briefly so we can defer to popup-close when that popup is shown.
    giftPopupWaitTimer = setTimeout(() => {
      if (!pendingBannerGifts?.length) return;

      if (isGiftAddedPopupOpen()) {
        awaitingGiftAddedPopup = true;
        return;
      }

      awaitingGiftAddedPopup = false;
      flushPendingGiftBanner();
    }, 450);
  }

  function maybeAnnounceNewGifts(gifts) {
    const currentKeys = new Set(gifts.map((g) => g.key));

    if (!giftsBootstrapped) {
      prevGiftKeys = currentKeys;
      giftsBootstrapped = true;

      const mount = ensureGiftsMount();
      if (mount) {
        mount.innerHTML = '';
        mount.hidden = true;
        mount.classList.remove('is-visible');
      }

      return;
    }

    const newlyAdded = gifts.filter((g) => !prevGiftKeys.has(g.key));
    prevGiftKeys = currentKeys;

    if (newlyAdded.length) {
      queueGiftBanner(newlyAdded);
    }
  }

  document.addEventListener('pb:gift-added-popup:closed', () => {
    awaitingGiftAddedPopup = false;
    clearTimeout(giftPopupWaitTimer);

    // CTA closes then opens cart; dismiss may leave cart already open from addLine.
    // Defer so drawer paint / cart:open can settle first.
    setTimeout(flushPendingGiftBanner, 120);
  });

  let lastSig = '';

  // Call before an optimistic DOM write so the next render() always repaints, even
  // when the server cart comes back byte-for-byte identical.
  function invalidateSignature() {
    lastSig = '';
  }

  function signature(cart) {
    const itemsSig = (cart.items || [])
      .map((i) => {
        if (i.isPickMixGroup) {
          return `${i.key}:${i.pickMixCount}:${i.original_line_price}:${i.final_line_price}:pm`;
        }

        if (i.isMixMatchGroup) {
          return `${i.key}:${i.quantity}:${i.original_line_price}:${i.final_line_price}:mm`;
        }

        if (i.isMarathonGroup) {
          return `${i.key}:${i.quantity}:${i.original_line_price}:${i.final_line_price}:mb`;
        }

        return `${i.key}:${i.quantity}:${i.original_line_price}:${i.final_line_price}:${i.isBundle ? 'b' : 'n'}:${i.isPickMixTransformedLine ? 'pmt' : ''}:${i.pickMixCount || 0}`;
      })
      .join('|');

    return `${itemsSig}@${cart.total_price}@${cart.currency || ''}`;
  }

  function renderBadge(cart) {
    if (!countBadgeEl) return;

    const count = Number(cart.item_count || 0);

    if (count > 0) {
      countBadgeEl.hidden = false;
      countBadgeEl.textContent = String(count);
    } else {
      countBadgeEl.hidden = true;
      countBadgeEl.textContent = '0';
    }
  }

  function renderSubtotal(cart) {
    if (!subtotalEl) return;

    const items = cart.items || [];

    const giftDeduction = items.reduce((sum, item) => {
      if (item.properties && (item.properties._beauty_bag === 'true' || !!item.properties._pb_gift)) {
        return sum + Number(item.final_line_price || 0);
      }
      return sum;
    }, 0);

    const before = Number(cart.original_total_price) - giftDeduction || 0;
    const after = Number(cart.total_price) - giftDeduction || 0;
    const discountTotal = Math.max(0, before - after);
    const formatted = formatMoney(after);

    subtotalEl.innerHTML = `<span class="ucd-money">${formatted}</span>`;

    if (checkoutSubtotalEl) {
      checkoutSubtotalEl.textContent = formatted;
    }

    if (discountRowEl && discountAmountEl) {
      const codes = cart.discount_codes || [];
      const label = discountRowEl.querySelector('span');
      if (label) label.textContent = codes.length ? `Korting · ${codes.join(', ')}` : 'Korting';
      if (discountTotal > 0) {
        discountRowEl.hidden = false;
        discountAmountEl.textContent = `-${formatMoney(discountTotal)}`;
      } else {
        discountRowEl.hidden = true;
        discountAmountEl.textContent = `-${formatMoney(0)}`;
      }
    }
  }

  function render(cart) {
    if (!list) return;

    const sig = signature(cart);
    lastRenderedCart = cart;

    if (sig === lastSig) {
      renderSubtotal(cart);
      renderBadge(cart);
      return;
    }

    lastSig = sig;

    const items = cart.items || [];

    // The campaign gift line renders in the gift card, not in the list.
    const cardLine = hasPaidItems(items) ? findCampaignGiftLine(items) : null;
    const listItems = cardLine ? items.filter((item) => item !== cardLine) : items;

    if (!items.length) {
      maybeAnnounceNewGifts([]);

      list.innerHTML = `
        <div class="empty-cart-container">
          <div class="empty-cart-image">
            <img src="https://cdn.shopify.com/s/files/1/0276/8430/7018/files/empty_cart.png?v=1750336414" alt="Empty Cart Icon">
          </div>
          <div class="empty-cart-title">Je winkelwagen is leeg</div>
          <a href="/collections/all" class="empty-cart-link">← Verder winkelen</a>
        </div>
      `;
    } else {
      const gifts = items.filter(isGiftItem);

      maybeAnnounceNewGifts(gifts);
      list.innerHTML = GIFT_CARD_MOUNT_HTML + listItems.map(lineItemHTML).join('');
      bindEvents(listItems);
      bindBundleToggles();
    }

    renderGiftCard(cart);
    renderSubtotal(cart);
    renderBadge(cart);
  }

  let t;

  function schedule() {
    clearTimeout(t);

    t = setTimeout(() => {
      fetchCart()
        .then(render)
        .catch((err) => {
          log('fetch error', err);

          if (list) {
            list.innerHTML = `<li class="ucd-empty">Kan cart niet laden.</li>`;
          }
        });
    }, 120);
  }

  function lineSetLoading(li, on) {
    if (!li) return;

    li.classList.toggle('is-loading', !!on);

    let spin = li.querySelector('.ucd-line-spinner');

    if (!spin) {
      spin = document.createElement('span');
      spin.className = 'ucd-line-spinner ucd-spinner';
      spin.setAttribute('aria-hidden', 'true');
      li.appendChild(spin);
    }

    spin.style.display = on ? 'inline-block' : 'none';

    li.querySelectorAll('.ucd-qty-btn, .ucd-remove, .ucd-remove1').forEach((el) => {
      el.disabled = !!on;
      el.setAttribute('aria-disabled', on ? 'true' : 'false');
    });
  }

  function initOnce() {
    schedule();
  }

  document.addEventListener('DOMContentLoaded', initOnce);
  document.addEventListener('pb:cart:updated', (e) => {
    const cart = e.detail?.cart;

    announceCartWarnings(e.detail?.warnings);

    if (cart?.lines) {
      render(normalizeCart(cart));
      return;
    }
    schedule();
  });
  document.addEventListener('cart:open', schedule);
})();